import firebase from 'firebase/app';
import 'firebase/database';
import 'firebase/firestore';
import 'firebase/storage'

import React, { useState, useEffect } from "react";

import { useFirestoreDocData, useFirestoreDocDataOnce, useFirestore, SuspenseWithPerf, useFirestoreCollectionData } from 'reactfire';

export function useContestsData () {

    const [isLoading, setIsLoading] = useState(null);
    const [isError, setIsError] = useState(null);
    const [currentData, setCurrentData] = useState(null);
    const [hasLoaded, setHasLoaded] = useState(false);
    
    const refContests = useFirestore()
    .collection('gamingContest');

    const dataContests = useFirestoreCollectionData(refContests);

    useEffect(() => {

        console.log('Data Change', dataContests);

        if(dataContests.status === "loading"){
            setCurrentData(null);
            setHasLoaded(false);
        } else if(dataContests.status === "success"){
            if(dataContests.data){
                setCurrentData(dataContests.data);
            }

            setHasLoaded(true);
        }

    },[dataContests, dataContests.status])

    useEffect(() => {

        if(currentData !== null && currentData !== undefined){
            console.log(`Current Data`, currentData);


        }

    },[currentData])

    return {
        data: currentData,
        hasLoaded: hasLoaded,
    }

}
